import { useEffect, useState } from "react";
// import { DataGrid } from "devextreme-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionPolicyList, resetPolicyList } from "../store";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import DataGrid, {
  Button,
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  Search,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../../common/app_constant";
import toast from "react-hot-toast";
import moment from "moment";
import { getLocalStorageItem, onExporting } from "../../../../../utils";
import BulkUpload from "../../../../../component/bulk_upload";
import BulkDocumentUpload from "../../../../../component/popups/bulk_document";
import Loader from "../../../../../component/page_loader";
import { useForm } from "react-hook-form";
import RcUpload_Document from "../../../../../component/rc_document_upload";
import { ProgressBar } from "devextreme-react";
import { SUB_DIRECTORY } from "../../../../../common/constant";

import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";

const PolicyList = () => {
  const { register, watch, setValue } = useForm();
  const [viewPolicyList, setViewPolicyList] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();


  const [documentBulk, setDocumentBulk] = useState(false);
  const [isUploadDoc, setIsUploadDoc] = useState(false);
  const [policyData, setPolicyData] = useState();
  const [uploadBulk, setUploadBulk] = useState(false);
  const [role, setRole] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const watchStatus = watch("status");

  const receivedData = location.state?.data || null;

  const { PolicyList } = useSelector((state) => ({
    ...state.listStore,
  }));

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));

  const [fromDate, setFromDate] = useState(
    receivedData?.from
      ? moment(receivedData?.from).format("YYYY-MM-DD")
      : // : moment(new Date()).subtract(2, "month").format("YYYY-MM-DD")
      ""
  );
  const [toDate, setToDate] = useState(
    receivedData?.to
      ? moment(receivedData?.to).format("YYYY-MM-DD")
      : // : moment(new Date()).add(4, "month").format("YYYY-MM-DD")
      ""
  );
  const [selectedDateFilter, setSelectedDateFilter] = useState("all");
  const dateFilterOptions = [
    { label: "Today", dateOption: "today" },
    { label: "Week", dateOption: "currentweek" },
    { label: "Previous Month", dateOption: "previousmonth" },
    { label: "Current Month", dateOption: "currentmonth" },
    { label: "Next Month", dateOption: "nextmonth" },
    { label: "Financial Year", dateOption: "financialYear" },
    { label: "ALL Data", dateOption: "all" },
  ];

  // for api call
  useEffect(() => {
    setRole(getLocalStorageItem("next"));

    dispatch(
      actionPolicyList({
        from_date: fromDate,
        to_date: toDate,
        status: watchStatus,
      })
    );
  }, []);

  const addFourYears = (date) => {
    if (!date) return null;
    const [year, month, day] = date.split('-').map(Number);
    const newDate = new Date(year, month - 1, day);
    newDate.setFullYear(newDate.getFullYear() + 4);
    return newDate; // Returns Date object
};

 const getMonth = (date) => {
    if (!date) return "-";
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return "-"; // Check if invalid
    return new Intl.DateTimeFormat("en-US", { month: "long" }).format(dateObj);
};

  const renderConcatinatedCell = (data) => {
    const formattedString =
      data.vehicle_make && data.vehicle_model
        ? data.vehicle_make + " - " + data.vehicle_model
        : "-";
    return formattedString;
  };


  // function updateRenewalStatus(policies) {
  //   const updatedPolicies = policies.map(policy => ({
  //     ...policy,
  //     quote: { ...(policy.quote || {}) }, // Clone quote safely
  //   }));

  //   const groupedByVehicle = {};

  //   // Group policies by vehicle
  //   for (const policy of updatedPolicies) {
  //     if (!groupedByVehicle[policy.vehicle_no]) {
  //       groupedByVehicle[policy.vehicle_no] = [];
  //     }
  //     groupedByVehicle[policy.vehicle_no].push(policy);
  //   }

  //   for (const vehicle in groupedByVehicle) {
  //     const policiesForVehicle = groupedByVehicle[vehicle];

  //     // Sort policies by policy_start_date in descending order (most recent first)
  //     policiesForVehicle.sort(
  //       (a, b) => new Date(b.policy_start_date) - new Date(a.policy_start_date)
  //     );

  //     for (let i = 0; i < policiesForVehicle.length; i++) {
  //       const current = policiesForVehicle[i];

  //       // If policy_expiry_date is not available, continue to next policy
  //       if (!current.policy_expiry_date) {
  //         current.quote.renewal_status = "Pending";
  //         continue;
  //       }

  //       const isExpired = new Date(current.policy_expiry_date) < new Date();
  //       console.log(`Policy Expired: ${isExpired}, Policy No: ${current.policy_no}`);

  //       // Find the next policy for the same vehicle after the expiry of the current policy
  //       const nextPolicy = policiesForVehicle.find((p) => {
  //         return (
  //           (p.previous_policy_id === current.id ||
  //             p.previous_policy_no === current.policy_no) &&
  //           new Date(p.policy_start_date) > new Date(current.policy_expiry_date)
  //         );
  //       });
  //       console.log(`Next Policy: ${nextPolicy ? nextPolicy.policy_no : 'None'}`);

  //       // Check if there's any manual entry for previous policy number tagging
  //       const manualRenewal = updatedPolicies.some((p) => {
  //         return (
  //           p.previous_policy_no === current.policy_no &&
  //           p.vehicle_no === current.vehicle_no
  //         );
  //       });
  //       console.log(`Manual Renewal: ${manualRenewal}`);

  //       // Check if the new policy started within 60 days of the previous policy expiry
  //       const isRenewedNearby = updatedPolicies.some((p) => {
  //         if (p.vehicle_no !== current.vehicle_no || p.id === current.id) return false;

  //         const startDate = new Date(p.policy_start_date);
  //         const expiryDate = new Date(current.policy_expiry_date);
  //         const days = (startDate - expiryDate) / (1000 * 60 * 60 * 24);

  //         console.log(`Days Between Policies: ${days}`);
  //         return days >= -60 && days <= 60;
  //       });

  //       console.log(`Is Renewed Nearby: ${isRenewedNearby}`);

  //       // If expired and a next policy, manual renewal, or nearby renewal exists, mark as Renewed
  //       if (isExpired && (nextPolicy || isRenewedNearby || manualRenewal)) {
  //         current.quote.renewal_status = "Renewed";
  //         current.status = "Success"; // Set the status as Success for renewed policies
  //       } else {
  //         current.quote.renewal_status = "Pending";
  //       }
  //     }
  //   }

  //   return updatedPolicies;
  // }




  const isRenewedPolicy = (item, allPolicies) => {
    return allPolicies?.some(p => {
      if (p.vehicle_no !== item.vehicle_no || p.id === item.id) return false;

      const startDate = new Date(p.policy_start_date);
      const expiryDate = new Date(item.policy_expiry_date);
      const days = (startDate - expiryDate) / (1000 * 60 * 60 * 24);

      return days >= -60 && days <= 60;
    });
  };



  useEffect(() => {
    dispatch(resetPolicyList());
    if (PolicyList != null) {
      if (PolicyList.status == true) {
        setIsLoader(false);

        // const updatedArray = PolicyList.data?.policyList?.map((item, index) => ({
        //   ...item,
        //   s_no: index + 1,
        //   year_completion_date: addFourYears(item?.capitalization_date),
        //   month: getMonth(item?.capitalization_date),
        //   vehicle_make_model: (renderConcatinatedCell(item))
        // }));

        // setViewPolicyList(updatedArray);


        const updatedArray = PolicyList.data?.policyList?.map((item, index) => {
          // Check if the policy is renewed using isRenewedPolicy function
          const renewed = isRenewedPolicy(item, PolicyList.data?.policyList);

          return {
            ...item,
            s_no: index + 1,
            year_completion_date: addFourYears(item?.capitalization_date),
            month: getMonth(item?.capitalization_date),
            vehicle_make_model: renderConcatinatedCell(item),
            quote: {
              ...item?.quote,
              renewal_status: renewed ? 'Renewed' : item?.quote?.renewal_status
            }
          };
        });

        setViewPolicyList(updatedArray);


      } else {
        setIsLoader(false);
        switch (PolicyList.status_code) {
          case 400:
            toast.error(PolicyList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [PolicyList]);

  // api call on date change
  useEffect(() => {
    dispatch(
      actionPolicyList({
        from_date: fromDate,
        to_date: toDate,
        status: watchStatus,
      })
    );
  }, [toDate, fromDate, watchStatus]);

  const onDownloadDocumentClick = (event) => {
    if (event && event.row && event.row.data) {
      const { documents } = event.row.data;

      if (Array.isArray(documents)) {
        // Extracting dms_id from PolicyDocument
        const dmsIds = documents
          .map(doc => doc.PolicyDocument?.dms_id)
          .filter(id => id !== undefined); // Removing undefined values if any

        console.log('dmsIds:', dmsIds);

        if (dmsIds.length > 0) {
          dispatch(actionDownload({ dmsIds }));
        } else {
          alert("This policy has no documents available.");
        }
      }
    }
  };



  const renderAction = (data) => (
    <>
      {role == "copsdashboard" && (
        <button
          className={`btn btn-sm btn-primary cursor-pointer`}
          onClick={() => {
            if (data) {
              console.log(JSON.stringify(data));
              // redirection in same window
              // navigate("/employer/policies/update", { state: { data: data } });

              // redirection in new window
              localStorage.setItem("detailsData", JSON.stringify(data));
              const url = `/employer/policies/update`;

              const win = window.open(url, "_blank");
              if (win) {
                win.focus();
              } else {
                console.log(
                  "Pop-up blocked. Please allow pop-ups for this site."
                );
              }
            }
          }}
        >
          Edit
        </button>
      )}

      <button
        className={`btn btn-sm btn-primary cursor-pointer mx-1`}
        onClick={() => {
          // redirection in same window
          // if (data) {
          //   navigate("/employer/policies/details", { state: { data: data } });
          // }

          // redirection in new window
          localStorage.setItem("detailsData", JSON.stringify(data));
          const url = `/employer/policies/details`;

          const win = window.open(url, "_blank");
          if (win) {
            win.focus();
          } else {
            console.log("Pop-up blocked. Please allow pop-ups for this site.");
          }
        }}
      >
        View
      </button>

      {
        !!(role != "copsdashboard" && !data?.vehicle_no) &&
        <button
          className="btn btn-sm btn-primary fs-7"
          onClick={() => {
            setPolicyData(data)
            setIsUploadDoc(true);
          }}
        >
          Upload RC
        </button>
      }
    </>
  );

  const renderAmountFixed = (data) => {
    const amountFormat = data ? Number(data).toFixed(0) : "-";
    return amountFormat;
  };

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  function setFilterDates(dateOption) {
    switch (dateOption) {
      case "today":
        setFromDate(moment().format("YYYY-MM-DD"));
        setToDate(moment().format("YYYY-MM-DD"));
        break;
      case "currentweek":
        setFromDate(moment().clone().startOf("isoweek").format("YYYY-MM-DD"));
        setToDate(moment().clone().endOf("isoweek").format("YYYY-MM-DD"));
        break;
      case "previousmonth":
        setFromDate(
          moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD")
        );
        setToDate(
          moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD")
        );
        break;
      case "currentmonth":
        setFromDate(moment().startOf("month").format("YYYY-MM-DD"));
        setToDate(moment().endOf("month").format("YYYY-MM-DD"));
        break;
      case "nextmonth":
        setFromDate(
          moment().add(1, "month").startOf("month").format("YYYY-MM-DD")
        );
        setToDate(moment().add(1, "month").endOf("month").format("YYYY-MM-DD"));
        break;
      case "financialYear":
        const currentFinancialYear = getCurrentFinancialYear();
        console.log(currentFinancialYear); // Output: "2023-2024"
        setFromDate(moment(currentFinancialYear.fromdate).format("YYYY-MM-DD"));
        setToDate(moment(currentFinancialYear.todate).format("YYYY-MM-DD"));
        break;
      case "all":
        setFromDate("");
        setToDate("");
        break;
    }
    console.log("date changesd==============>", fromDate, toDate);
  }

  // function for financial year
  function getCurrentFinancialYear() {
    const today = moment();
    const currentYear = today.year();
    const fiscalYearStartMonth = 3; // April is month 3 in moment.js

    const startYear =
      today.month() < fiscalYearStartMonth ? currentYear - 1 : currentYear;

    return { fromdate: `${startYear}-04-01`, todate: `${startYear + 1}-03-31` };
  }

  const renderDateCell = (date) => {
    const formattedDate = moment(date).isValid()
      ? moment(date).format("DD-MMM-YYYY")
      : "-";
    return formattedDate;
  };

  const renderDaysCell = (date) => {
    const daysRemaining =
      moment(date).isValid() &&
      moment(date, "YYYY/MM/DD").diff(moment(), "days");
    return daysRemaining;
  };

  // Current Status Field

  // policy_received_status = "No"
  // then show = Under Process

  // policy_received_status = "Yes" and policy_doc_status = "No"
  // then show = Document Pending

  // policy_received_status = "Yes" and policy_doc_status = "Yes"
  // then show = Issued

  const renderCurrentStatus = (data) => {
    if (
      data.status === "Document Pending"
    ) {
      return <span class="fw-bold text-warning">Document Pending</span>;
    } else if (
      data.status === "Issued"
    ) {
      return <span class="fw-bold text-success">Issued</span>;
    } else {
      return <span class="fw-bold text-danger"> Under Process </span>;
    }
  };

  const onExportingData = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Policy List");

    const allowedColumns = [
      "userDetails.full_name",
      "userDetails.email",
      "userDetails.userCity.cityState.stateZone.name",
      "vehicle_no",
      "vehicle_make_model",
      "chassis",
      "engine_no",
      "cubic_capacity",
      "capitalization_date",
      "year_completion_date",
      "month",
    ]; // ✅ Only these columns are allowed

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeColumns: (columns) => {
        // ✅ Remove ALL columns that are not in allowedColumns
        columns = columns.filter(column => allowedColumns.includes(column.dataField));

        // ✅ Add "S.No" column manually at the beginning
        columns.unshift({
          caption: "S.No",
          dataField: "s_no",
          allowExporting: true
        });
      },
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell) {
          const field = gridCell.column?.dataField;

          // ✅ Format date fields correctly
          if (["capitalization_date", "year_completion_date"].includes(field) && gridCell.value) {
            excelCell.value = moment(gridCell.value).format("DD-MM-YYYY");
          }
        }
      },
      selectedRowsOnly: false, // ✅ Export all rows
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }),
          "PolicyList.xlsx"
        );
      });
    });

    e.cancel = true; // ✅ Prevent default export
  };

  console.log("Current Role:", role);
  console.log("Condition Result:", !(role === "employerdashboard" || role === "superuserdashboard"));

  return (
    <>
      <div className="row justify-content-center pb-5 mt-6">
        <div className="col-12 mb-5">
          <div className="d-flex justify-content-between mb-2">
            <h5 className="mb-0">Policy Listss</h5>
            <div>
              {role == "copsdashboard" && (
                <>
                  <button
                    className={`btn btn-sm btn-primary cursor-pointer me-2`}
                    onClick={() => {
                      localStorage.removeItem("detailsData");
                      navigate("/employer/policies/update");
                    }}
                  >
                    Add
                  </button>
                  <button
                    className={`btn btn-sm btn-primary cursor-pointer me-2`}
                    onClick={() => {
                      setDocumentBulk(true);
                    }}
                  >
                    Add Document Bulk
                  </button>
                  <button
                    className={`btn btn-sm btn-primary cursor-pointer`}
                    onClick={() => {
                      setUploadBulk(true);
                    }}
                  >
                    Add Bulk
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="card p-3 ">
            <h6>Filters</h6>
            <div class="row mt-1">
              <div class="col-12 col-md-3 ">
                <label>Policy Due Date From</label>
                <input
                  type="date"
                  name="start_date"
                  value={fromDate}
                  onChange={(event) => {
                    setFromDate(event.target.value);
                  }}
                  className="form-control form-control-lg"
                />
              </div>
              <div class="col-12 col-md-3 ">
                <label>Policy Due Date To</label>
                <input
                  type="date"
                  name="end_date"
                  value={toDate}
                  onChange={(event) => {
                    setToDate(event.target.value);
                  }}
                  className="form-control form-control-lg"
                />
              </div>
              {/* <div class="col-12 col-md-2 ">
                <button type="submit" className="btn btn-primary w-100 btn-lg h-100 ">Submit</button>
              </div> */}
              <div class="col-12 col-md-2 ">
                <button
                  type="submit"
                  className="btn btn-secondary w-80 mt-4"
                  onClick={() => {
                    setValue('status', '')
                    setSelectedDateFilter("all");
                    setFromDate(
                      receivedData?.from
                        ? moment(receivedData?.from).format("YYYY-MM-DD")
                        : // : moment(new Date())
                        //   .subtract(2, "month")
                        //   .format("YYYY-MM-DD")
                        ""
                    );
                    setToDate(
                      receivedData?.to
                        ? moment(receivedData?.to).format("YYYY-MM-DD")
                        : // : moment(new Date())
                        //   .add(4, "month")
                        //   .format("YYYY-MM-DD")
                        ""
                    );
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
          {isLoader === true ? (
            <Loader />
          ) : (
            <div className="card border mt-3">
              <div className="card-header">
                <div className="form-group">
                  <div className="btn-group btn-group-sm flex-wrap d-flex w-100" role="group">
                    {dateFilterOptions.map(({ label, dateOption }, index) => (
                      <button
                        key={index}
                        type="button"
                        className={`btn btn-outline-primary mb-2 me-2 ${selectedDateFilter === dateOption ? "active" : ""}`}
                        onClick={() => {
                          setSelectedDateFilter(dateOption);
                          setFilterDates(dateOption);
                        }}
                      >
                        {label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="card-body position-relative">
                {/* Renewal status Filter */}
                <div className=" position-absolute w-25 z-index-9 ">
                  <select
                    class="form-select fw-bold text-primary"
                    name="status"
                    {...register("status")}
                    aria-label="select example"
                  >
                    <option value='' selected>All{watchStatus == '' && `(${viewPolicyList?.length})`}</option>
                    <option value='document_pending'>Document Pending{watchStatus === 'document_pending' && `(${viewPolicyList?.length})`}</option>
                    <option value="issued">Issued {watchStatus === 'issued' && `(${viewPolicyList?.length})`}</option>
                    <option value="under_process">
                      Under Process {watchStatus === 'under_process' && `(${viewPolicyList?.length})`}
                    </option>
                  </select>
                </div>
                <DataGrid
                  id="claim_list"
                  dataSource={viewPolicyList}
                  columnMinWidth={100}
                  showBorders={true}
                  filterSyncEnabled={false}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onExporting={onExportingData}
                >
                  <HeaderFilter visible={true} />
                  <SearchPanel visible={true} />
                  <FilterRow visible={true} />
                  {/* {role == "copsdashboard" && ( */}
                  <Column
                    dataField="action"
                    cellRender={({ data }) => renderAction(data)}
                    caption="Action"
                    allowExporting={false}
                  ></Column>
                  {/* )} */}
                  <Column
                    dataField="s_no"
                    caption="S.No"
                  />
                  {role == "copsdashboard" && (
                    <Column
                      width={50}
                      dataField="customer_group"
                      caption="Company Name"
                    ></Column>
                  )}
                  <Column dataField="biz_type" caption="Type" />

                  <Column
                    dataField="userDetails.full_name"
                    caption="Emp Name"
                  />
                  <Column
                    dataField="userDetails.email"
                    caption="Emp Email ID"
                    dataType="string"
                  />

                  <Column
                    dataField="userDetails.userCity.cityState.stateZone.name"
                    caption="Emp Zone"
                  />
                  <Column dataField="vehicle_no" caption="Vehicle Number " />

                  <Column
                    dataField="vehicle_make_model"
                    caption="Vehicle Make & Model"
                    width={80}

                  />

                  <Column dataField="chassis" caption="Chassis No" />
                  <Column dataField="engine_no" caption="Engine No" />
                  <Column dataField="cubic_capacity" caption="Cubic Capacity" />


                  <Column
                    dataField="userDetails.mobile"
                    caption="Emp Mobile"
                    dataType="string"
                  />
                  <Column dataField="policy_no" caption="Policy Number" />


                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column dataField="paid_through" caption="Paid Through" />
                  )}

                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="policy_expiry_date"
                      caption="Policy Due Date"
                      dataType="date"
                      cellRender={({ value }) => renderDateCell(value)}
                    />)}
                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="policy_expiry_date"
                      caption="Renewal Due Days "
                      cellRender={({ value }) => renderDaysCell(value)}
                    />)}
                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column dataField="policy_type" caption="Policy Type" />
                  )}
                  <Column dataField="sub_type" caption="Policy Sub Type" />
                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (

                    <Column
                      dataField="sum_insured"
                      caption="IDV"
                      dataType="number"
                      cellRender={({ value }) => renderAmountFixed(value)}
                    />)}
                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="gross_premium"
                      caption="Gross Premium  "
                      dataType="number"
                      cellRender={({ value }) => renderAmountFixed(value)}
                    />)}
                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column dataField="current_plan" caption="Add-on Plan" />
                  )}


                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column dataField="insurer_name" caption="Insurer Name  " />
                  )}


                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="status"
                      caption="Current Status "
                      cellRender={({ data }) => renderCurrentStatus(data)}
                    />)}


                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="is_active_claim"
                      caption="Claim"
                      cellRender={({ data }) =>
                        data?.is_active_claim ? "Yes" : "No"
                      }
                    />)}



                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="quote.renewal_status"
                      caption="Renewal Status"
                    />)}



                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="quote.renewal_final_amt"
                      caption="Renewal Premium"
                      cellRender={({ data }) =>
                        data?.quote?.renewal_status == "Quote Confirm"
                          ? data?.quote?.renewal_final_amt
                          : "-"
                      }
                    />)}



                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="quote.renewal_plan_final"
                      caption="Renewal Plan"
                      cellRender={({ data }) =>
                        data?.quote?.renewal_status == "Quote Confirm"
                          ? data.quote.renewal_plan_final
                          : "-"
                      }
                    />)}



                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField=""
                      caption="Cd Recovery"
                      cellRender={({ data }) =>
                        data?.cd_recovery_date ? "Yes" : "No"
                      }
                    />

                  )}

                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (
                    <Column
                      dataField="cd_recovery_amount"
                      caption="Recovery Amount"
                      dataType="number"
                      cellRender={({ value }) => renderAmountFixed(value)}
                    />
                  )}

                  {role !== undefined && !(role === "employerdashboard" || role === "superuserdashboard") && (

                    <Column
                      dataField="cd_recovery_date"
                      caption="Recovery Date"
                      dataType="date"
                      cellRender={({ value }) => renderDateCell(value)}
                    />
                  )}

                  <Column
                    dataField="capitalization_date"
                    caption="Capitalization Date"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />


                  <Column
                    dataField="year_completion_date"
                    caption="4th Year Completion Date"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />

                  <Column
                    dataField="month"
                    caption="Month"
                    dataType="month"
                  />

                  {/* <Column dataField="policy_received_status" caption="policy_received_status " />
                 <Column dataField="policy_doc_status" caption="policy_doc_status " /> */}




                  <Column
                    dataField="dmsIds"
                    type="buttons"
                    width={100}
                    caption="Download Policy"
                  >
                    <Button
                      onClick={onDownloadDocumentClick}
                      name="downloadPolicy"
                      icon="download"
                    />
                  </Column>
                  <Column
                    dataField="lastUpdatedBy.full_name"
                    caption="Last Modified By "
                  />
                  <Column
                    dataField="modify_date"
                    caption="Last Modified Date "
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Export enabled={true} />
                </DataGrid>
              </div>
            </div>
          )}
          <BulkDocumentUpload
            show={documentBulk}
            handleClose={() => {
              setDocumentBulk(false);
            }}
          />
          <RcUpload_Document
            show={isUploadDoc}
            policyObj={policyData}
            handleClose={() => {
              setIsUploadDoc(false);
              setIsLoader(true)
              dispatch(
                actionPolicyList({
                  from_date: fromDate,
                  to_date: toDate,
                  status: watchStatus,
                })
              );
            }}
          />
          <BulkUpload
            sampleFileName={`${SUB_DIRECTORY}/documents/policies data.csv`}
            show={uploadBulk}
            module="policy"
            dynamic_url="importpolicies"
            handleUpdateList={() => {
              setUploadBulk(false);
              dispatch(
                actionPolicyList({
                  from_date: fromDate,
                  to_date: toDate,
                  status: watchStatus,
                })
              );
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PolicyList;
